import { Controller, SubmitHandler, useForm } from 'react-hook-form';
import { IMaskInput } from 'react-imask';
import * as S from './styled';
//hooks
import apiRequest from '../../../../hooks/apiRequest';
import useLoading from '../../../../hooks/useLoading';
//Components
import LayoutModal from '../../../LayoutModal';
//Interfaces
import { ICreate } from 'Interfaces/ICreate';
import { Inputs } from 'Interfaces/ISupllier';

export default function Create({
  isOpenModal,
  setModalClose,
  refreshFrames,
  setToastOpen,
  setToastData,
}: ICreate) {
  const {
    register,
    handleSubmit: handleFormSubmit,
    control,
    reset,
    formState: { errors },
  } = useForm<Inputs>();

  const { isLoading, startLoading, stopLoading } = useLoading();

  const onSubmit: SubmitHandler<Inputs> = async (data) => {
    startLoading();
    try {
      const formattedData = {
        ...data,
        name: data.name.toUpperCase(),
      };

      const response = await apiRequest('supplier', 'POST', formattedData);
      if (response.status === 201) {
        setToastData({
          status: response.status,
          message: 'Cadastrado com sucesso!',
        });

        setToastOpen(true);
        refreshFrames();
        onClose();
      }
    } catch (error: any) {
      setToastData({
        status: error?.response?.status || 500,
        message: error.message || 'Erro inesperado',
      });

      setToastOpen(true);
    } finally {
      stopLoading();
    }
  };

  const onClose = () => {
    setModalClose();
    reset();
  }

  if (isOpenModal) {
    return (
      <LayoutModal
        statusLoad={isLoading}
        title="Registrar Fornecedor"
        subTitle="Cadastre um novo fornecedor em sua base de dados."
        setModalClose={onClose}
        submiteModal={handleFormSubmit(onSubmit)}

        nameIconMinimize={'Registrar Fornecedor'}
      >
        <S.Container>
          <S.FormInput>
            <S.Label>
              Nome do Fornecedor
              <span>*</span>
            </S.Label>
            <S.Input
              placeholder="Informe o fornecedor"
              type="text"
              {...register("name", { required: true })}
            />
            {errors.name && <S.InforErro>Campo Obrigatório</S.InforErro>}
          </S.FormInput>

          <S.FormInput>
            <S.Label>Contato</S.Label>
            <Controller
              name="contact"
              control={control}
              render={({ field }) => (
                <IMaskInput
                  className="imask"
                  id="phone_primary"
                  mask="(00) 00000-0000"
                  placeholder="(99) 99999-9999"
                  {...field}
                />
              )}
            />
          </S.FormInput>

          <S.FormInput>
            <S.Label>E-mail</S.Label>
            <S.Input
              placeholder="exemplo@gmail.com"
              type="email"
              {...register("email")}
            />
          </S.FormInput>

          <S.FormInput>
            <S.Label>Descrição</S.Label>
            <S.TextArea
              placeholder="Campo Opcional"
              rows={2}
              {...register("description")}
            />
          </S.FormInput>
        </S.Container>
      </LayoutModal>
    );
  }
  return null;
}